import { MODELS } from '../content';

export function Models() {
  return (
    <section className="section hairline-t" id="models">
      <div className="container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            gap: 20,
            marginBottom: 54,
          }}
        >
          <div style={{ maxWidth: 560 }}>
            <div className="eyebrow" style={{ marginBottom: 18 }}>
              Seven models
            </div>
            <h2 className="h-title">One studio, seven ways to study form.</h2>
          </div>
          <p style={{ color: 'var(--fg-3)', fontSize: 14, maxWidth: 280, margin: 0 }}>
            From planar heads to full figures — each model trains a different part of your eye.
          </p>
        </div>
        <div
          className="models-grid"
          style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}
        >
          {MODELS.map((m) => (
            <div
              key={m.id}
              className="ticks"
              style={{
                border: '0.5px solid var(--line-2)',
                borderRadius: 4,
                overflow: 'hidden',
                background: 'var(--bg-2)',
              }}
            >
              <span className="tick-br"></span>
              <div
                style={{
                  height: 230,
                  position: 'relative',
                  overflow: 'hidden',
                  background:
                    'radial-gradient(120% 90% at 40% 25%, #15151b, #0a0a0d 70%)',
                }}
              >
                {m.pro && (
                  <span
                    className="mono"
                    style={{
                      position: 'absolute',
                      top: 12,
                      right: 12,
                      zIndex: 1,
                      fontSize: 9.5,
                      letterSpacing: '0.12em',
                      textTransform: 'uppercase',
                      padding: '3px 7px',
                      borderRadius: 3,
                      border: '0.5px solid var(--line-2)',
                      background: 'rgba(0,0,0,0.45)',
                      color: 'var(--fg-2)',
                    }}
                  >
                    Pro
                  </span>
                )}
                <img
                  src={m.img}
                  alt={`${m.name} model preview`}
                  loading="lazy"
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '52%',
                    transform: 'translate(-50%,-50%)',
                    height: '88%',
                    width: 'auto',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 24px 40px rgba(0,0,0,0.6))',
                  }}
                />
              </div>
              <div
                style={{
                  padding: '16px 18px',
                  borderTop: '0.5px solid var(--line-1)',
                }}
              >
                <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.01em' }}>
                  {m.name}
                </div>
                <div
                  className="mono"
                  style={{
                    fontSize: 10.5,
                    color: 'var(--fg-3)',
                    marginTop: 3,
                    letterSpacing: '0.02em',
                  }}
                >
                  {m.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
